export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Мониторинг: Журнал событий",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
